import classnames from 'classnames'

import Player from 'modules/transmission/components/player/player'
import { ThankYouThumbnail } from 'modules/transmission/components/thankYou'
import {
  PlaybackStatus,
  Status,
  Transmission
} from 'modules/transmission/types'
import GtagHelper, { Subsection } from 'common/helpers/gtag'
import useLayout from 'common/hooks/useLayout'
import TriggerRenderer from 'modules/trigger/components/triggerRenderer'
import LiveInfo from 'modules/transmission/components/liveInfo'
import LiveBadges from 'modules/transmission/components/liveBadges'
import UnexpectedErrorMask from 'modules/transmission/components/unexpectedErrorMask'
import { usePostLeadContext } from 'modules/lead/context'

import './videoContainer.scss'

export interface Props {
  transmission: Transmission,
  isHotmartProvider: boolean,
  embedUrl: string,
  theaterMode: boolean,
  endPlayer: boolean
}

let sentLivePageview = false

const VideoContainer = ({
  transmission,
  isHotmartProvider,
  embedUrl,
  theaterMode,
  endPlayer
}: Props) => {
  const { isDesktop, isMobile } = useLayout()
  const {
    response: { contactId: userId }
  } = usePostLeadContext()

  const showUnexpectedError
    = transmission.playbackStatus === PlaybackStatus.DISCONNECTED
    && transmission.status === Status.STARTED

  const sendPageView = () => {
    if (transmission && !sentLivePageview && userId) {
      const liveSource = GtagHelper.getLiveSource(transmission.createdFrom)

      GtagHelper.sendPageView({
        userId,
        subsection: Subsection.LIVE,
        subsection2: liveSource,
        logged: true,
        liveSource
      })

      sentLivePageview = true
    }
  }

  const renderPlayer = () => {
    sendPageView()

    return (
      <Player
        key="player"
        embedUrl={embedUrl}
        leadCode={userId}
        isHotmartProvider={isHotmartProvider}
        transmission={transmission}
        theaterMode={theaterMode}/>
    )
  }

  const renderFooter = () => (
    <div className="video-footer" data-test="footer">
      <div className="video-footer-content">
        <LiveBadges liveStatus={transmission.status} />
        <LiveInfo
          title={transmission.name}
          description={transmission.description}/>
      </div>
      {isDesktop && theaterMode && (
        <TriggerRenderer className="footer-trigger" dataTest="footer-trigger" />
      )}
    </div>
  )

  return (
    <div
      className={classnames('video-container left-column', {
        'theater-mode': theaterMode
      })}>
      <div className="player-container">
        <div className="player-container-content">
          {endPlayer ? (
            <ThankYouThumbnail
              key="thank-you-thumbnail"
              alt={transmission.name}
              src={transmission.largeThumbnailLink}/>
          ) : (
            renderPlayer()
          )}
        </div>
        {showUnexpectedError && <UnexpectedErrorMask />}
      </div>
      {!endPlayer && isMobile && (
        <TriggerRenderer className="player-trigger" dataTest="player-trigger" />
      )}
      {isDesktop && renderFooter()}
    </div>
  )
}

export default VideoContainer
